import { render } from "./betSure.vue?vue&type=template&id=5861c005&scoped=true"
import script from "./betSure.vue?vue&type=script&lang=js"
export * from "./betSure.vue?vue&type=script&lang=js"

import "./betSure.vue?vue&type=style&index=0&id=5861c005&lang=scss&scoped=true"
import "./betSure.vue?vue&type=style&index=1&id=5861c005&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5861c005"]])

export default __exports__